module.exports = {
      id: "highlights-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "svg-sprite-3f41b5422aa8d7a50bd372d0b736cd55.svg#highlights",
      toString: function () {
        return this.url;
      }
    }